import React, {useState} from 'react';
import { Flex } from "antd";
import {BackButton} from "../../../../shared";
import {StyledCard} from "./Header.styled";
import {useLocation, useNavigate} from "react-router-dom";
import { CloseOutlined } from '@ant-design/icons';

const Header = () => {

    return (
        <StyledCard>
            <Flex vertical gap={"middle"}>
                <Flex justify={"space-between"} align={"center"} gap={"middle"}>
                    <Flex gap={"small"} align={"center"}>
                        <BackButton/>
                        <span>پنل مدیریت</span>

                    </Flex>
                </Flex>
            </Flex>
        </StyledCard>
    )

};

export default Header;
